import React from "react";
import { Colors } from "../../Constants/colors";
import { CircularProgress } from "@mui/material";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { useMobile, useTab } from "../../hooks/deviceHooks/useDevice.hooks";

export enum BtnSize {
  sm = "sm",
  md = "md",
  lg = "lg",
}
export enum BtnType {
  primary = "primary",
  secondary = "secondary",
  basic = "basic",
}
interface Props {
  loading?: boolean;
  text: string;
  btnStyle?: object;
  onClick?: () => unknown;
  btnSize?: BtnSize;
  btnType?: BtnType;
  requiresValidationOnSubmit?: boolean;
  className?: string;
}

//TODO MAKE BUTTON TYPE, BUTTON SIZE DYNAMIC
export const Button = ({
  loading = false,
  text,
  btnStyle = {},
  onClick = () => {},
  btnSize = BtnSize.md,
  btnType = BtnType.secondary,
  requiresValidationOnSubmit = false,
  className = "",
}: Props) => {
  const onButtonClicked = (callback: () => unknown) => {
    //Can add other functionality here if required
    callback();
  };
  const isMobile = useMobile();
  const isTab = useTab();

  // const buttonClassName = () => {
  //   let baseButtonClassName =
  //     "rounded-md w-full flex justify-center items-center";
  //   switch (btnSize) {
  //     case BtnSize.lg:
  //       baseButtonClassName += " lg:w-1/2 md:w-1/2 h-14";
  //       break;
  //     case BtnSize.md:
  //       baseButtonClassName += " lg:w-60 w-20 lg:h-12 h-8";
  //       break;
  //     case BtnSize.sm:
  //       baseButtonClassName += " w-6 h-11";
  //       break;
  //     default:
  //       return baseButtonClassName;
  //   }
  //   return baseButtonClassName;
  // };

  const buttonColor = () => {
    switch (btnType) {
      case BtnType.secondary:
        return Colors.TangerineOrange;
      case BtnType.primary:
        return Colors.CrimsonRed;
      case BtnType.basic:
        return Colors.WhiteSmoke;
      default:
        return Colors.TangerineOrange;
    }
  };
  const borderColor = () => {
    switch (btnType) {
      case BtnType.basic:
        return Colors.DarkOffWhite;
      default:
        return "";
    }
  };
  const buttonTextColor = () => {
    switch (btnType) {
      case BtnType.basic:
        return Colors.Black;
      default:
        return Colors.White;
    }
  };
  return (
    <button
      // className={buttonClassName()}
      style={{
        backgroundColor: buttonColor(),
        border: `1px solid ${borderColor()}`,
        padding: "10px",
        color: Colors.White,
        width: isMobile || isTab ? "100%" : "150px",
        height: isMobile || isTab ? "40px" : "50px",
        borderRadius: "8px",
        ...btnStyle,
      }}
      onClick={() => onButtonClicked(onClick)}
    >
      {loading ? (
        <CircularProgress
          variant="indeterminate"
          size={25}
          style={{
            color: btnType === BtnType.basic ? Colors.AshRose : Colors.White,
          }}
        />
      ) : (
        <div
          style={{
            color: buttonTextColor(),
            fontFamily: FontFamily.ROBOTO_REGULAR,
            fontSize: isMobile ? "12px" : "18px",
          }}
          className="font-medium"
        >
          {text}
        </div>
      )}
    </button>
  );
};
